/* ============================================================
   WebMCP: exposes the store's key actions as tools for
   browser-embedded AI agents (Chrome's navigator.modelContext).
   Experimental API: everything is feature-detected and wrapped,
   so this is a silent no-op in browsers without WebMCP.
   Spec: https://webmachinelearning.github.io/webmcp/
   ============================================================ */
(function () {
  'use strict';
  if (!('modelContext' in navigator)) return;
  var mc = navigator.modelContext;
  if (!mc || typeof mc.provideContext !== 'function') return;

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var info = theme.storeInfo || {};

  function text(s) { return { content: [{ type: 'text', text: typeof s === 'string' ? s : JSON.stringify(s) }] }; }

  try {
    mc.provideContext({
      tools: [
        {
          name: 'search_products',
          description: 'Search the Anime Alley catalog (TCG singles, sealed product, supplies, event tickets). Returns matching products with title, url, price and availability.',
          inputSchema: { type: 'object', properties: { query: { type: 'string', description: 'Card name, set, or product to search for' } }, required: ['query'] },
          async execute(args) {
            var url = (routes.predictive_search || '/search/suggest') + '.json?q=' +
              encodeURIComponent(args.query) + '&resources[type]=product&resources[limit]=10';
            var r = await fetch(url, { headers: { Accept: 'application/json' } });
            var d = await r.json();
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            return text(ps.map(function (p) {
              return { title: p.title, url: p.url, price: p.price, available: p.available };
            }));
          }
        },
        {
          name: 'add_to_cart',
          description: 'Add a product variant to the shopping cart by its numeric variant id (from the product page or search results).',
          inputSchema: { type: 'object', properties: { variant_id: { type: 'number' }, quantity: { type: 'number', description: 'Defaults to 1' } }, required: ['variant_id'] },
          async execute(args) {
            var r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: args.variant_id, quantity: args.quantity || 1 })
            });
            var d = await r.json();
            if (!r.ok) return text('Could not add to cart: ' + (d.description || d.message || 'unknown error'));
            return text('Added to cart. Review and check out at /cart');
          }
        },
        {
          name: 'get_cart',
          description: 'Get the current shopping cart contents and total.',
          inputSchema: { type: 'object', properties: {} },
          async execute() {
            var r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            var d = await r.json();
            return text({
              item_count: d.item_count,
              total: d.total_price / 100,
              currency: d.currency,
              items: (d.items || []).map(function (i) {
                return { title: i.product_title, variant: i.variant_title, quantity: i.quantity, price: i.price / 100, url: i.url };
              }),
              checkout_url: '/checkout'
            });
          }
        },
        {
          name: 'get_store_info',
          description: 'Get Anime Alley store details: address, phone, hours, and how to sell cards to the shop (buylist).',
          inputSchema: { type: 'object', properties: {} },
          async execute() {
            return text({
              name: info.name || 'Anime Alley',
              address: info.address || '667 Yonge St, Toronto, ON M4Y 1Z9',
              phone: info.phone || '(416) 591-7699',
              hours: info.hours || 'Open till 7PM',
              sells: 'Pokemon, Magic: The Gathering, One Piece and Riftbound singles, sealed product and supplies. Hosts weekly events.',
              buylist: 'Sell cards to the shop with same-day payment at ' + (info.buylist || 'https://buylist.animealley.ca'),
              events: '/pages/events'
            });
          }
        }
      ]
    });
  } catch (e) { /* experimental API surface changed: stay silent */ }
})();
